export default "__VITE_ASSET__d1e2e23e__"